import { useAuth } from 'context/authentication/useAuth'
import { Navigate, Outlet } from 'react-router-dom'
import * as S from './styles'
import LoadingScreen from '../../../components/Layout/LoadingScreen'
import { MobileUnauthenticatedNav } from 'components/Layout/Navbar/MobileUnauthenticatedNav'
import { MobileUnauthenticatedFooter } from 'components/Layout/Footer/MobileFooter'

export function MobileAuthLayout() {
  const { isAuthenticated, isCheckingAuth } = useAuth()

  if (isCheckingAuth) return <LoadingScreen />

  if (isAuthenticated) return <Navigate to="/" />

  return (
    <S.Container>
      <MobileUnauthenticatedNav />
      <S.MobileContent>
        <Outlet />
      </S.MobileContent>
      <MobileUnauthenticatedFooter />
    </S.Container>
  )
}
